import { FaSquareFacebook } from "react-icons/fa6"
import { TiSocialInstagram } from "react-icons/ti"
import Logo from "./icons/Logo"

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-400 py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-8">
          <div>
            <div className="flex items-center gap-2 text-white mb-4">
              <Logo width="30px" stroke="white" />
              <span className="text-2xl font-bold">AutoLink</span>
            </div>
            <p className="text-sm">
              ¡Vende o compra tu auto al mejor precio. Rápido, fácil y sin
              complicaciones!
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold my-4">Services</h4>
            <div className="space-y-2">
              <a
                href="/#servicios"
                className="block hover:text-white transition"
              >
                Servicio de Búsqueda
              </a>
              <a
                href="/#servicios"
                className="block hover:text-white transition"
              >
                Servicio de Venta
              </a>
              <a
                href="/#servicios"
                className="block hover:text-white transition"
              >
                Inspección de Vehículos
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-white font-semibold my-4">Compañía</h4>
            <div className="space-y-2">
              <a href="/#" className="block hover:text-white transition">
                Nosotros
              </a>
              <a
                href="/#testimonios"
                className="block hover:text-white transition"
              >
                Testimonios
              </a>
              <a
                href="https://wa.link/2xqw6j"
                rel="noopener noreferrer"
                target="_blank"
                className="block hover:text-white transition"
              >
                Contacto
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-white font-semibold my-4">Contacto</h4>
            <div className="space-y-2 flex flex-col">
              <p>Bogotá, Colombia</p>
              <a
                href="https://wa.link/2xqw6j"
                rel="noopener noreferrer"
                target="_blank"
                className="hover:text-white transition"
              >
                Whatsapp +(57) 3024195336
              </a>
              <a
                className=" hover:text-white transition"
                href="mailto:autolinkcolombia@gmail.com?subject=Consulta&body=Escribe tu consulta aquí"
              >
                autolinkcolombia@gmail.com
              </a>
              <div className="flex gap-1 items-center">
                <a
                  href="https://www.instagram.com/invites/contact/?utm_source=ig_contact_invite&utm_medium=copy_link&utm_content=xlcxmso"
                  className="hover:text-gray-50"
                  target="_blank"
                >
                  <TiSocialInstagram size={30} />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61574863285686"
                  className="hover:text-gray-50"
                  target="_blank"
                >
                  <FaSquareFacebook size={26} />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8">
          <p className="text-center text-sm">
            © 2025 AutoLink. Todos Los Derechos Reservados.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
